import { StyleConfig, StyleName, StyleVariant } from "../../../types";

export type SetupScopedStyleConfig = {
  recordPageContainer: Record<string, StyleName>;
  multiSections: Record<string, StyleName>;
  sections: Record<string, StyleName | StyleVariant[]>;
  sectionsTitle: Record<string, StyleName>;
  sectionInfoBtn: Record<string, StyleName>;
  sectionForm: Record<string, StyleName | StyleVariant[]>;
  fields: Record<string, StyleName>;
};

const createEmptySetupStyle = (): SetupScopedStyleConfig => ({
  recordPageContainer: {},
  multiSections: {},
  sections: {},
  sectionsTitle: {},
  sectionInfoBtn: {},
  sectionForm: {},
  fields: {},
});

export const SETUP_STYLES: Record<string, SetupScopedStyleConfig> = {
  InventoryBuildings: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      InventoryBuildings: "side-sheet-record-page-layout",
    },
    sections: {
      building_details: "inventory-building-details-section-layout",
      zone_details: "inventory-building-zone-details-section-layout",
      route_details: "inventory-building-route-details-section-layout",
    },
    sectionsTitle: {
      zone_details: "hidden",
      route_details: "hidden",
    },
    sectionInfoBtn: {
      building_details: "hidden",
      zone_details: "hidden",
      route_details: "hidden",
    },
    sectionForm: {
      building_details: "inventory-building-details-form-layout",
    },
  },
  AccountsPayable: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      AccountsPayable: "privlib-record-page-layout",
    },
    sectionForm: {
      AP_options: "section-vertical",
    },
  },
  CAPDefaults: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      CAPDefaults: "privlib-record-page-layout",
    },
  },
  CREDefaults: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      CREDefaults: "privlib-record-page-layout",
    },
  },
  PaymentTypes: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      PaymentTypes: "privlib-record-page-layout",
    },
  },
  Checks: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      Checks: "privlib-record-page-layout",
    },
  },
  InvoiceAutoPost: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      InvoiceAutoPost: "privlib-record-page-layout",
    },
    sectionForm: {
      exception_info: "section-stacked-two-column-layout",
    },
  },
  PORoleLevelInfo: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      PORoleLevelInfo: "privlib-record-page-layout",
    },
  },
  SEFlag: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      SEFlag: "privlib-record-page-layout",
    },
  },
  EtcAbsenceCodes: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      EtcAbsenceCodes: "dashboard-record-page-layout",
    },
    sectionsTitle: {
      general_fields: "hidden",
    },
    sectionInfoBtn: {
      classification_reference_fields: "hidden",
      general_fields: "hidden",
    },
    sectionForm: {
      classification_reference_fields: "section-fields-full-width",
      general_fields: {
        recordClosed: "section-with-background",
      },
    },
  },
  EtcHolidays: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      EtcHolidays: "dashboard-record-page-layout",
    },
    sectionsTitle: {
      general_fields: "hidden",
    },
    sectionInfoBtn: {
      general_fields: "hidden",
    },
    sectionForm: {
      general_fields: {
        recordClosed: "section-with-background",
      },
    },
  },
  EtcPayrollFields: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      EtcPayrollFields: "dashboard-record-page-layout",
    },
    sectionsTitle: {
      general_fields: "hidden",
    },
    sectionInfoBtn: {
      general_fields: "hidden",
    },
    sectionForm: {
      general_fields: {
        recordClosed: "section-with-background",
      },
    },
  },
  EtcTardyCodes: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      EtcTardyCodes: "dashboard-record-page-layout",
    },
    sectionsTitle: {
      general_fields: "hidden",
    },
    sectionInfoBtn: {
      general_fields: "hidden",
    },
    sectionForm: {
      tardy_code_fields: {
        recordClosed: "section-with-background",
      },
      general_fields: {
        recordClosed: "section-with-background",
      },
    },
  },
  
  VendorPaymentTypes: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      VendorPaymentTypes: "dashboard-record-page-layout",
    },
    sectionsTitle: {
      general_fields: "hidden",
    },
    sectionInfoBtn: {
      vendor_payment_fields: "hidden",
      general_fields: "hidden",
    },
    sectionForm: {
      vendor_payment_fields: {
        recordClosed: "section-with-background",
      },
      general_fields: {
        recordClosed: "section-with-background",
      },
    },
  },
  RemitToParent: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      RemitToParent: "dashboard-record-page-layout",
    },
    sectionsTitle: {
      general_fields: "hidden",
    },
    sectionInfoBtn: {
      general_fields: "hidden",
    },
    sectionForm: {
      general_fields: {
        recordClosed: "section-with-background",
      },
    },
  },
  Make: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      Make: "dashboard-record-page-layout",
    },
    sectionsTitle: {
      general_fields: "hidden",
    },
    sectionInfoBtn: {
      general_fields: "hidden",
    },
    sectionForm: {
      general_fields: {
        recordClosed: "section-with-background",
      },
    },
  },
  Model: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      Model: "dashboard-record-page-layout",
    },
    sectionsTitle: {
      general_fields: "hidden",
    },
    sectionInfoBtn: {
      general_fields: "hidden",
    },
    sectionForm: {
      general_fields: {
        recordClosed: "section-with-background",
      },
    },
  },
  Story: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      Story: "dashboard-record-page-layout",
    },
    sectionsTitle: {
      general_fields: "hidden",
    },
    sectionInfoBtn: {
      general_fields: "hidden",
    },
    sectionForm: {
      general_fields: {
        recordClosed: "section-with-background",
      },
    },
  },
  GroupCodes: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      GroupCodes: "dashboard-record-page-layout",
    },
    sectionsTitle: {
      general_fields: "hidden",
    },
    sectionInfoBtn: {
      general_fields: "hidden",
    },
    sectionForm: {
      general_fields: {
        recordClosed: "section-with-background",
      },
    },
  },
  POUnitsOfMeasure: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      POUnitsOfMeasure: "dashboard-record-page-layout",
    },
    sectionsTitle: {
      general_fields: "hidden",
    },
    sectionInfoBtn: {
      general_fields: "hidden",
    },
    sectionForm: {
      general_fields: {
        recordClosed: "section-with-background",
      },
    },
  },
  VendorCategory: {
    ...createEmptySetupStyle(),
    sectionsTitle: {
      vendor_category_fields: "hidden",
      general_fields: "hidden",
    },
    sectionInfoBtn: {
      vendor_category_fields: "hidden",
      general_fields: "hidden",
    },
    sectionForm: {
      vendor_category_fields: {
        recordClosed: "section-horizontal",
      },
      general_fields: {
        recordClosed: "section-horizontal",
      },
    },
    fields: {
      category_description: "field-with-button",
    },
  },
  VendorCompanyType: {
    ...createEmptySetupStyle(),
    sectionsTitle: {
      vendor_company_fields: "hidden",
      general_fields: "hidden",
    },
    sectionInfoBtn: {
      vendor_company_fields: "hidden",
      general_fields: "hidden",
    },
    sectionForm: {
      vendor_company_fields: {
        recordClosed: "section-horizontal",
      },
      general_fields: {
        recordClosed: "section-horizontal",
      },
    },
    fields: {
      company_type: "field-with-button",
    },
  },
  EtcPayPeriod: {
    ...createEmptySetupStyle(),
    fields: {
      max_overtime_hours_per_day: "field-size-small",
      max_overtime_hours_per_week: "field-size-small",
      max_hours_per_day_before_doubletime: "field-size-small",
      max_hours_on_7th_day_before_doubletime: "field-size-medium",
    },
  },
  Journals: {
    ...createEmptySetupStyle(),
    sectionForm: {
      journal_options: "two-column-layout",
    },
  },
  RecurringJournalEntries: {
    ...createEmptySetupStyle(),
    sectionsTitle: {
      recurring_entry_reference: "hidden",
    },
    sectionInfoBtn: {
      recurring_entry_reference: "hidden",
    },
  },
  JournalTemplates: {
    ...createEmptySetupStyle(),
    sectionsTitle: {
      journal_template_entry_reference: "hidden",
    },
    sectionInfoBtn: {
      journal_template_entry_reference: "hidden",
    },
  },
  CashInBanks: {
    ...createEmptySetupStyle(),
    sectionForm: {
      report_options: "section-vertical",
    },
    fields: {
      accounts: "field-size-large-with-large-chip",
    },
  },
  LaserFormTable: {
    ...createEmptySetupStyle(),
    fields: {
      chk_laser_printer_no: "grid-new-row",
    },
  },
  PaymentMappings: {
    ...createEmptySetupStyle(),
    recordPageContainer: {
      PaymentMappings: "dashboard-record-page-layout",
    },
    sectionsTitle: {
      general_fields: "hidden",
    },
    sectionInfoBtn: {
      general_fields: "hidden",
    },
    sectionForm: {
      general_fields: {
        recordClosed: "section-with-background",
      },
    },
  },
  CashClearingSetup: {
    ...createEmptySetupStyle(),
    fields: {
      cash_in_bank_company_group_id: "field-size-small",
      cash_clearing_company_group_id: "field-size-small",
    },
  },
};

export const DASHBOARD_LEVEL_SETUPS = [
  "EtcAbsenceCodes",
  "EtcHolidays",
  "EtcPayrollFields",
  "EtcTardyCodes",
  "VendorPaymentTypes",
  "RemitToParent",
  "Model",
  "Make",
  "Story",
  "ReportGroupCodes",
  "POUnitsOfMeasure",
  "PaymentMappings",
];

export const SINGLE_FIELD_DASHBOARD_LEVEL_SETUPS = [
  "VendorCategory",
  "VendorCompanyType",
];

export const NORMAL_TAB_SETUPS = ["Discounts"];

export const SIDE_SHEET_SETUPS: string[] = [];

export const STYLE_CONFIG: StyleConfig = Object.values(SETUP_STYLES).reduce(
  (acc, setupStyle) => {
    Object.assign(acc.recordPageContainer, setupStyle.recordPageContainer);
    Object.assign(acc.multiSections, setupStyle.multiSections);
    Object.assign(acc.sections, setupStyle.sections);
    Object.assign(acc.sectionsTitle, setupStyle.sectionsTitle);
    Object.assign(acc.sectionInfoBtn, setupStyle.sectionInfoBtn);
    Object.assign(acc.sectionForm, setupStyle.sectionForm);
    Object.assign(acc.fields, setupStyle.fields);
    return acc;
  },
  {
    recordPageContainer: {},
    multiSections: {},
    sections: {},
    sectionsTitle: {},
    sectionInfoBtn: {},
    sectionForm: {},
    fields: {},
  } as StyleConfig,
);
